import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'lfw-toolbar-button',
  templateUrl: './app-toolbar-button.component.html',
  styleUrl: './app-toolbar-button.component.scss',
  imports: [MatIcon, MatTooltip]
})
export class AppToolbarButtonComponent {
  label = input.required<string>();
  icon = input.required<string>();
  tooltip = input<string>();
  disabled = input(false);
}
